
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg","opacity":".4"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#112A46","fill":"none","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.625 2.5c-2.39 0-3.125.735-3.125 3.125S3.235 8.75 5.625 8.75 8.75 8.015 8.75 5.625 8.015 2.5 5.625 2.5zM5.625 11.25c-2.39 0-3.125.735-3.125 3.125S3.235 17.5 5.625 17.5s3.125-.735 3.125-3.125-.735-3.125-3.125-3.125zM14.375 11.25c-2.39 0-3.125.735-3.125 3.125s.735 3.125 3.125 3.125 3.125-.735 3.125-3.125-.735-3.125-3.125-3.125zM14.375 2.5c-2.39 0-3.125.735-3.125 3.125s.735 3.125 3.125 3.125S17.5 8.015 17.5 5.625 16.765 2.5 14.375 2.5z"}})])])
          )
        }
      }
    